import { render, staticRenderFns } from "./SysCategoryDictModal.vue?vue&type=template&id=ba640460&"
import script from "./SysCategoryDictModal.vue?vue&type=script&lang=js&"
export * from "./SysCategoryDictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports